/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlayerRecord = createReactComponent("outline", "player-record", "IconPlayerRecord", [["path", { "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }]]);

export { IconPlayerRecord as default };
//# sourceMappingURL=IconPlayerRecord.mjs.map
